import { z } from 'zod'
import { TRAINER_CONTRACT_VERSION } from './trainer-event-read'

/** Storage/upload signed-URL and long-poll contracts stay intentionally loose: handlers keep exact validation order and status branching. */
const storageObject = z.object({
  contract_version: z.literal(TRAINER_CONTRACT_VERSION),
}).passthrough()


export const trainerResourceUploadOperationResponseSchema = storageObject
export type TrainerResourceUploadOperationResponse = z.infer<typeof trainerResourceUploadOperationResponseSchema>
